import BaseEndpoint from "../endpoints/baseEndpoint";
import useAuthUser from "../hooks/useAuthUser";

const parseTimer = (raw) => {
    if (!raw) {
        return { instruksi: 60, ujian: 1800 };
    }
    let value = raw;
    while (typeof value === "string") {
        try {
            const parsed = JSON.parse(value);
            value = parsed;
        } catch (error) {
            break;
        }
    }
    if (!value || typeof value !== "object") {
        return { instruksi: 60, ujian: 1800 };
    }
    return {
        instruksi: Number(value?.instruksi ?? value?.instruction ?? 60),
        ujian: Number(value?.ujian ?? value?.exam ?? value?.duration ?? 1800),
    };
};

export default async function getTesAkademik(version, id) {
    const authData = useAuthUser();
    let token = authData?.user?.token;
    if (!token) {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get("token");
    }
    if (!token) {
        try {
            const rawAuth = JSON.parse(localStorage.getItem('authUser'));
            token = rawAuth?.token;
        } catch (e) {}
    }

    const tokenQuery = token ? `&token=${encodeURIComponent(token)}` : "";

    try {
        const sessionData = await BaseEndpoint.instance().get(
            `/exam/${version}/instruction?id=${id}${tokenQuery}`
        );
        const soalData = await BaseEndpoint.instance().get(
            `/exam/${version}?id=${id}${tokenQuery}`
        );

        let sessions = [];

        let data = sessionData.data;
        if (Array.isArray(data)) {
            data = data.find(m => String(m.id) === String(id)) || data[0] || {};
        }
        if (!data) data = {};

        let timer = parseTimer(data.timer);

        let instructionDuration = (timer.instruksi > 0 ? timer.instruksi : 60) * 1000;
        let examDuration = (timer.ujian > 0 ? timer.ujian : 1800) * 1000;

        let instruksiContent = data.instruksi && data.instruksi.trim() !== ""
            ? data.instruksi
            : "Silakan kerjakan soal-soal tes akademik berikut dengan teliti.";

        sessions.push({
            name: data.nama_mapel || "Tes Akademik",
            type: "instruction",
            content: instruksiContent,
            duration: instructionDuration,
        });

        let questions = Array.isArray(soalData.data) ? soalData.data : [];

        sessions.push({
            name: data.nama_mapel || "Tes Akademik",
            type: "exam",
            content: questions,
            duration: examDuration,
        });

        return sessions;
    } catch (error) {
        console.error('Error loading Tes Akademik session:', error);
        return [];
    }
}
